import { ApiService } from '@services/api.service';

export class MyUploadAdapter {
	loader;  // your adapter communicates to CKEditor through this
	apiService: ApiService;

	constructor(loader, apiService) {
		this.loader = loader;
		this.apiService = apiService;
		console.log('Upload Adapter Constructor', this.loader);
	}

	upload() {
		console.log('UploadAdapter upload called', this.loader);
		return this.loader.file
			.then( file => new Promise( ( resolve, reject ) => {
				//console.log('UploadAdapter upload called', file);

				const formData = new FormData();
				formData.append('file', file);

				return this.apiService.post("images", formData).then((data) => {
					resolve({default: data.url});
				}, (response) => {
					reject("Error uploading file " +  response.error.statusCode + " " + response.error.message);
				});

			}));
	}

	abort() {
		console.log('UploadAdapter abort');
	}
}
